import { Autocomplete, Box, FormControl, Grid, TextField } from '@mui/material';
import LoadingWheel from '../../../components/ui/LoadingWheel';
import { useContext } from 'react';
import { StockCountZonesContext, StockCountZonesContextValues } from '../contexts/StockCountZonesContext';

const StockCountZonesMain = () => {
  const {
    t,
    zoneName,
    stores,
    selectedStores,
    setSelectedStores,
    setZoneName,
    isCreating,
    isLoading,
  } = useContext(StockCountZonesContext) as StockCountZonesContextValues;

  if (isLoading) {
    return (
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
        width: '100%',
      }}>
        <LoadingWheel />
      </Box>
    );
  }
  return (
    <Box sx={{ border: '1px solid', py: '12px', px: '8px' }}>
      <Grid container
        spacing={5}>
        <Grid item
          xs={12}
          md={4}>
          <FormControl fullWidth>
            <TextField
              label={t('countZoneName')}
              variant="outlined"
              value={zoneName}
              onChange={(e) => setZoneName(e.target.value)}
              disabled={!isCreating}
              required
            />
          </FormControl>
        </Grid>

        <Grid item
          xs={12}
          md={8}>
          <Autocomplete
            multiple
            options={stores}
            getOptionLabel={(option) => option.storeName ?? ''}
            isOptionEqualToValue={(option, value) => option.storeNumber === value.storeNumber}
            value={stores?.filter(option => selectedStores.includes(option.storeNumber ?? '')) ?? []}
            onChange={(event, newValue) => {
              const newStoreNumbers = newValue
                .map(s => s.storeNumber)
                .filter(Boolean) as string[];
              setSelectedStores(newStoreNumbers);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t('selectStores')}
                placeholder={t('selectStores')}
                size="small"
              />
            )}
          />
        </Grid>

      </Grid>
    </Box>
  );
};

export default StockCountZonesMain;